import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"
import { useFiltersAuthKeys } from "@/pages/SettingsPage/application/auth/useAuthKeys"

import type { AuthKeyType } from "@/api/useAuthKeys.types"

export const FilterAuthKeysTab = ({ keyType }: { keyType: AuthKeyType }) => {
  const { response, isLoading } = useFiltersAuthKeys(keyType)
  const filters = response?.data?.all

  return (
    <Filter.Provider isLoading={isLoading}>
      <Filter.Template
        isLoading={isLoading}
        search={
          isLoading ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch id={`Filter${keyType}`} filters={filters} />
          )
        }
      />
    </Filter.Provider>
  )
}
